import type { ContentProps } from '@workspace/core-ts/types';

export default {
    title: {
        site: (
            <>
                Ajouter des véhicules à votre <b>flotte</b>
            </>
        ),
        courtier: (
            <>
                Ajouter des véhicules à la <b>flotte de votre client</b>
            </>
        ),
    },
} as unknown as ContentProps;
